import { dispatcher } from '../dispatcher/dispatcher';
import Constants from '../constants/constants';
import { storeUtils } from './util';
const { ActionTypes } = Constants;
var _events = new storeUtils.EventEmitter();


var _attempts = 0;
var _idToPoll = {};
var _isPolling = false;
var _isBlocking = false;
var _stopPolling = false;
var _previousFormAControlNumber;

var dispatchToken = dispatcher.register(function (action) {

    //this action comes from the dispatcher
    switch (action.type) {

        case ActionTypes.SUBMITTING_TO_SERVER:
            _isBlocking = true;
            _events.trigger(ActionTypes.CHANGE_EVENT);
            break;

        case ActionTypes.SUBMIT_TO_SERVER_FAILED:
        case ActionTypes.SUBMIT_TO_SERVER_404_500:
        case ActionTypes.SUBMIT_TO_SERVER_VALIDATE_MP_FINISHED:
            _isBlocking = false;
            _events.trigger(ActionTypes.CHANGE_EVENT);
            break;

        case ActionTypes.NO_TSS_RESPONSE_ON_POLL:
            _attempts++;
            _events.trigger(ActionTypes.CHANGE_EVENT);
            break;


        case ActionTypes.INITIALIZE_POLL:
            _idToPoll = {};
            localStorage.pollId = JSON.stringify(_idToPoll);
            // console.log('Initialized poll id as [', _idToPoll, ']')
            _events.trigger(ActionTypes.CHANGE_EVENT);
            break;

        case ActionTypes.SUBMIT_TO_SERVER_SUCCESSFUL:

            var id = action.request.syncId;
            var op = action.submitAction;

            //store this for the message later
            if (action.request && action.request.restrictionDetail) {
                _previousFormAControlNumber = action.request.restrictionDetail.controlNumber;
            }

            if (id && op && Number.isInteger(id)) {
                if (!_idToPoll.id) {//not in list
                    _idToPoll = { id: id, op: op };
                    localStorage.pollId = JSON.stringify(_idToPoll);
                    // console.log('stored id to poll [', id, '] with operation:[', op, ']');
                    _events.trigger(ActionTypes.CHANGE_EVENT);
                }
                else
                    console.error('failed to store id [', id, '] poll id is already set as [', _idToPoll, ']')
            }
            else
                console.error('error storing [', id, '] with operation:[', op, ']');
            break;

        case ActionTypes.MF_ERROR_RETURNED:
        case ActionTypes.REMOVE_POLL_ID:
            _attempts = 0;
            _stopPolling = false;
            if (_idToPoll.id === action.id) {
                // console.log('Removing ID [', action.id, ']');
                _idToPoll = {}
            }
            else {
                console.error('Tried to remove id ' + action.id + ' but idToPoll is ' + _idToPoll.id, "Clearing ID to poll");
                _idToPoll = {};
            }
            localStorage.pollId = JSON.stringify(_idToPoll);
            _isBlocking = false;
            _events.trigger(ActionTypes.CHANGE_EVENT);
            break;


        case ActionTypes.START_POLL:
            _isPolling = true;
            _events.trigger(ActionTypes.CHANGE_EVENT);
            break;

        case ActionTypes.STOP_POLL:
            _isPolling = false;
            _events.trigger(ActionTypes.CHANGE_EVENT);
            break;

        case ActionTypes.KILL_POLLING_DUE_TO_ERROR:
            _isPolling = false;
            _stopPolling = true;
            _events.trigger(ActionTypes.CHANGE_EVENT);
            break;
        default:
        //no op
    }
});//end of dispatch token

function getBackOff() {
    var backOff = Constants.MaxValues.POLL_RETRY_WAIT_PERIOD;
    if (_attempts >= Constants.MaxValues.POLL_MAX_TRIES) {
        _stopPolling = true;
        // console.log('max attempts[{a}] reached'.replace('{a}', _attempts));
    }
    return backOff;
}

//public api
export const pollStore = {
    dispatchToken,
    subscribe: _events.on,
    unsubscribe: _events.off,
    idsToPoll: function () {
        return _idToPoll ? _idToPoll.id : ''
    },//.map(function(i){return i.id;});},
    idToPoll: function () {
        return _idToPoll ? _idToPoll.id : ''
    },//.map(function(i){return i.id;});},
    opForId: function (id) {
        if (_idToPoll.id === id) {
            return _idToPoll.op;
        }
        else
            return;
        //var item = _idsToPoll.find(function(i){return i.id === id});
        //return item && item.op;
    },
    isPolling: function () {
        return _isPolling;
    },
    getInterval: function () {
        return getBackOff()
    },
    itemsToPoll: function () {
        return _idToPoll;
    },
    isBlocking: function () {
        return _isBlocking;
    },
    stopPolling: function () {
        return _stopPolling;
    },
    getPreviousFormAControlNumber: function () {
        return _previousFormAControlNumber;
    }
};
